import { render, staticRenderFns } from "./BaseEChartPie.vue?vue&type=template&id=1b12b330&scoped=true"
import script from "./BaseEChartPie.vue?vue&type=script&lang=js"
export * from "./BaseEChartPie.vue?vue&type=script&lang=js"
import style0 from "./BaseEChartPie.vue?vue&type=style&index=0&id=1b12b330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b12b330",
  null
  
)

export default component.exports